import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { LogIn } from "lucide-react";

const DEMO = [
  { role: "Admin", email: "admin@tokoinduk.com", pw: "admin123" },
  { role: "Gudang", email: "gudang@tokoinduk.com", pw: "gudang123" },
  { role: "Driver", email: "driver@tokoinduk.com", pw: "driver123" },
  { role: "Finance", email: "finance@tokoinduk.com", pw: "finance123" },
];

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@tokoinduk.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("ti_token", r.data.token);
      localStorage.setItem("ti_user", JSON.stringify(r.data.user));
      toast.success(`Selamat datang, ${r.data.user.name}`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login gagal");
    }
    setLoading(false);
  };

  return (
    <div className="tech-grid min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-10">
      <Card className="glass glow-border bg-transparent rounded-2xl p-8 w-full max-w-md fade-up">
        <div className="pill-cyan mb-3">DASHBOARD PORTAL</div>
        <h1 className="font-display text-2xl font-bold text-white">Masuk Dashboard</h1>
        <p className="text-slate-400 text-sm mt-1">Admin · Gudang · Driver · Finance</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">Email</Label>
            <Input data-testid="login-email" value={email} onChange={e=>setEmail(e.target.value)} type="email" className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
          </div>
          <div>
            <Label className="text-slate-300 text-xs uppercase tracking-widest font-mono-metric">Password</Label>
            <Input data-testid="login-password" value={password} onChange={e=>setPassword(e.target.value)} type="password" className="mt-1.5 bg-slate-900/60 border-slate-700 text-white h-11"/>
          </div>
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full h-11 bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold">
            <LogIn className="w-4 h-4 mr-2"/>{loading ? "Masuk..." : "Login"}
          </Button>
        </form>

        <div className="mt-6 border-t border-slate-800 pt-4">
          <div className="text-[10px] font-mono-metric uppercase tracking-widest text-cyan-400 mb-2">DEMO ACCOUNTS (klik untuk isi)</div>
          <div className="grid grid-cols-2 gap-2">
            {DEMO.map(d => (
              <button
                key={d.email}
                data-testid={`demo-${d.role.toLowerCase()}`}
                type="button"
                onClick={() => { setEmail(d.email); setPassword(d.pw); }}
                className="text-left text-xs bg-slate-900/60 border border-slate-800 hover:border-cyan-500/40 rounded-md p-2"
              >
                <div className="text-cyan-300 font-semibold">{d.role}</div>
                <div className="text-slate-500 font-mono-metric truncate">{d.email}</div>
              </button>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
